export const referenceRoutes = {
  HOME: '/portfolio-manager',
  STATUS: '/status',
  NEW_STATUS: '/status/[status]',
  HOUSE_REGISTRATION: '/house-registration',
  HOUSE_REGISTRATION_SUCCESS: '/house-registration/success',
  DRAFTS_ONGOING: '/drafts/ongoing',
  DRAFTS_SUBMITTED: '/drafts/submitted',
  PHOTOS: '/photos',
  VISITS: '/visits',
  PROPERTY_OVERVIEW: '/property/[propertyId]/[section]',
  RENT_OFFERS: '/rent-offers/[offerStatus]',
  SALE_OFFERS: '/sale-offers/[offerStatus]',
  SALE_OFFERS_INTERNAL: '/sale-offers/internal/[offerStatus]',
  RENT_OFFER_DETAILS: '/rent-offer/details',
  RENT_OFFER_DETAILS_CANCELED: '/rent-offer/canceled/details',
  SALE_OFFER_DETAILS: '/sale-offer/details',
  SALE_OFFER_DETAILS_TIC: '/sale-offer/details/tic',
  SEARCH: '/search/[term]',
};

export const navItems = [
  ['Início', '/portfolio-manager'],
  ['Meus imóveis', '/status'],
  ['Cadastrar imóvel', '/house-registration'],
  ['Visitas', '/visits'],
  ['Propostas', '/rent-offers/IN_NEGOTIATION'],
  ['Membros', '/members'],
  ['Integração', '/integration'],
];

export const properties = [
  {
    id: '1001',
    crmId: 'A1001',
    address: 'Avenida Ataulfo de Paiva, 50 - Leblon, Rio de Janeiro',
    propertyType: 'Apartamento',
    area: 112,
    bedrooms: 3,
    bathrooms: 2,
    suites: 1,
    parking: 1,
    region: 'Leblon',
    city: 'Rio de Janeiro',
    status: 'Anunciado',
    businessContexts: ['Aluguel', 'Venda'],
    rentPrice: 7200,
    salePrice: 1520000,
    condoPrice: 1450,
    houseTax: 7200,
    ownerEarns: 6480,
    owner: 'Helena Paiva',
    representative: 'Claudete Galeasso',
    entry: 'Chaves com corretor',
    entryModel: 'Responsável pelas chaves',
    visitAuthorization: 'Entrada autorizada',
    description:
      'Apartamento antigo em excelente estado, último andar do prédio, espaçoso e iluminado.',
    availableItems: [
      'Armário na cozinha',
      'Armário no quarto',
      'Varanda',
      'Portaria 24h',
      'Perto de metrô ou trem',
      'Aceita pet',
    ],
    photos: 19,
  },
  {
    id: '1002',
    crmId: 'B1002',
    address: 'Rua Visconde de Pirajá, 210 - Ipanema, Rio de Janeiro',
    propertyType: 'Apartamento',
    area: 86,
    bedrooms: 2,
    bathrooms: 2,
    suites: 1,
    parking: 1,
    region: 'Ipanema',
    city: 'Rio de Janeiro',
    status: 'Com pendências',
    businessContexts: ['Aluguel'],
    rentPrice: 6100,
    salePrice: 1290000,
    condoPrice: 980,
    houseTax: 5400,
    ownerEarns: 5490,
    owner: 'Mauro Montenegro',
    representative: 'Bruna Almeida',
    entry: 'Proprietário abre o imóvel',
    entryModel: 'Proprietário ou representante',
    visitAuthorization: 'Aguardando confirmação',
    description: 'Imóvel com fotos pendentes e confirmação de disponibilidade em andamento.',
    availableItems: ['Varanda', 'Armário no quarto', 'Fogão/cooktop'],
    photos: 3,
  },
  {
    id: '1003',
    crmId: 'C1003',
    address: 'Rua Passagem, 129 - Botafogo, Rio de Janeiro',
    propertyType: 'Kitnet/Studio',
    area: 44,
    bedrooms: 1,
    bathrooms: 1,
    suites: 0,
    parking: 0,
    region: 'Botafogo',
    city: 'Rio de Janeiro',
    status: 'Em processamento',
    businessContexts: ['Venda'],
    rentPrice: 3900,
    salePrice: 780000,
    condoPrice: 620,
    houseTax: 3100,
    ownerEarns: 744000,
    owner: 'Barbara Mayer',
    representative: 'Paulo Salles',
    entry: 'Chaves na portaria',
    entryModel: 'Portaria',
    visitAuthorization: 'Autorizado',
    description: 'Studio em processamento com anúncio antecipado para visitas.',
    availableItems: ['Portaria 24h', 'Aceita pet'],
    photos: 11,
  },
];

export const homeTaskCards = [
  {
    id: 'REGISTER',
    title: 'Cadastrar imóvel',
    subtitle: 'Cadastro de Imóvel',
    count: null,
    href: '/house-registration',
    tone: 'highlight',
  },
  {
    id: 'OFFERS',
    title: 'Propostas',
    subtitle: '4 para responder',
    count: 4,
    href: '/rent-offers/IN_NEGOTIATION',
    tone: 'default',
  },
  {
    id: 'VISITS',
    title: 'Visitas',
    subtitle: '3 para confirmar',
    count: 3,
    href: '/visits',
    tone: 'default',
  },
  {
    id: 'STATUS_PENDING',
    title: 'Imóveis',
    subtitle: '1 para revisar',
    count: 1,
    href: '/status/pending?page=1',
    tone: 'warning',
  },
  {
    id: 'STATUS_PUBLISHED',
    title: 'Imóveis',
    subtitle: '1 anunciados',
    count: 1,
    href: '/status/published?page=1',
    tone: 'success',
  },
];

export const homeEmptyStates = [
  ['Sem propostas', 'Quando você tiver propostas, elas aparecerão aqui para que você possa avaliar e acompanhar.'],
  ['Nenhum imóvel', 'Nada para revisar'],
  ['Nenhum anunciado', 'Nada para confirmar'],
  ['Nada para responder', 'Tente novamente em alguns instantes.'],
];

export const statusReasonGroups = [
  ['Pendências', 'Faltam informações da pessoa proprietária'],
  ['Pendências', 'Preço desatualizado'],
  ['Pendências', 'Poucas fotos disponíveis'],
  ['Pendências', 'Qualidade das imagens abaixo do permitido'],
  ['Não elegível', 'Fora do preço de atuação do QuintoAndar'],
  ['Não elegível', 'Imóvel não residencial'],
  ['Não elegível', 'Fora da área de atuação do QuintoAndar'],
  ['Não elegível', 'Imóvel já existente no QuintoAndar'],
  ['Não elegível', 'Endereço não encontrado ou incompleto'],
  ['Processando', 'Imóvel na fila'],
  ['Processando', 'Pendências marcadas como resolvidas. Aguardando recebimento da atualização.'],
  ['Desativado', 'Proprietário pediu rescisão do contrato'],
  ['Desativado', 'Imóvel indisponível'],
  ['Desativado', 'Falta de confirmação de disponibilidade'],
];

export const statusTabs = [
  ['all', 'Todos'],
  ['published', 'Anunciados'],
  ['pending', 'Pendências'],
  ['processing', 'Processando'],
  ['unpublished', 'Desativados'],
];

export const statusRows = [
  {
    id: 'status-1001-rent',
    propertyId: '1001',
    crmId: 'A1001',
    address: properties[0].address,
    businessContext: 'Aluguel',
    value: 7200,
    status: 'Anunciado',
    detail: 'Anúncio com muita procura',
    reason: 'Na média dos similares na região',
    action: 'Ver anúncio',
    statusGroup: 'published',
  },
  {
    id: 'status-1002-rent',
    propertyId: '1002',
    crmId: 'B1002',
    address: properties[1].address,
    businessContext: 'Aluguel',
    value: 6100,
    status: 'Com pendências',
    detail: 'Poucas fotos disponíveis',
    reason: 'Faltam informações da pessoa proprietária',
    action: 'Resolver pendências',
    statusGroup: 'pending',
  },
  {
    id: 'status-1003-sale',
    propertyId: '1003',
    crmId: 'C1003',
    address: properties[2].address,
    businessContext: 'Venda',
    value: 780000,
    status: 'Em processamento',
    detail: 'Imóvel na fila',
    reason: 'Pendências marcadas como resolvidas. Aguardando recebimento da atualização.',
    action: 'Acompanhar',
    statusGroup: 'processing',
  },
  {
    id: 'status-1002-sale',
    propertyId: '1002',
    crmId: 'B1002',
    address: properties[1].address,
    businessContext: 'Venda',
    value: 1290000,
    status: 'Desativado',
    detail: 'Falta de confirmação de disponibilidade',
    reason: 'Proprietário não concorda com os termos do QuintoAndar',
    action: 'Reativar anúncio',
    statusGroup: 'unpublished',
  },
];

export const visits = [
  {
    id: 'VIS-1001-001',
    propertyId: '1001',
    address: properties[0].address,
    businessContext: 'Aluguel',
    status: 'Aguardando confirmação',
    date: '16/07/2026',
    time: '10:30',
    visitor: 'Mariana Lima',
    authorization: 'Entrada autorizada',
    filter: 'MY_SUPPLY',
  },
  {
    id: 'VIS-1002-001',
    propertyId: '1002',
    address: properties[1].address,
    businessContext: 'Aluguel',
    status: 'Visita confirmada',
    date: '17/07/2026',
    time: '14:00',
    visitor: 'Rafael Duarte',
    authorization: 'Proprietário precisa confirmar',
    filter: 'MY_CLIENTS',
  },
  {
    id: 'VIS-1003-001',
    propertyId: '1003',
    address: properties[2].address,
    businessContext: 'Venda',
    status: 'Horário expirou',
    date: '12/07/2026',
    time: '09:00',
    visitor: 'João Martins',
    authorization: 'Chaves na portaria',
    filter: 'LEAD_GEN',
  },
];

export const rentOffers = [
  {
    id: 'RF-301',
    propertyId: '1001',
    address: properties[0].address,
    buyer: 'Mariana Lima',
    offersCount: 2,
    status: 'Em negociação',
    value: 7000,
    listingValue: 7200,
    updatedAt: 'há 2 horas',
    customSolicitations: [
      'Solicita instalação de rede de proteção',
      'Negociação de entrada em 20/07/2026',
    ],
  },
  {
    id: 'RF-302',
    propertyId: '1002',
    address: properties[1].address,
    buyer: 'Rafael Duarte',
    offersCount: 1,
    status: 'Aceita',
    value: 6000,
    listingValue: 6100,
    updatedAt: 'há 1 dia',
    customSolicitations: ['Aceite pendente de documentação do proprietário'],
  },
  {
    id: 'RF-303',
    propertyId: '1003',
    address: properties[2].address,
    buyer: 'João Martins',
    offersCount: 1,
    status: 'Cancelada',
    value: 3900,
    listingValue: 3900,
    updatedAt: 'há 6 dias',
    customSolicitations: ['Cliente desistiu da visita'],
  },
];

export const saleOffers = [
  {
    id: 'SF-901',
    propertyId: '1001',
    address: properties[0].address,
    buyer: 'Fernanda Costa',
    status: 'Recebida',
    payment: 'Financiado + FGTS',
    creditStatus: 'Crédito aprovado',
    value: 1480000,
    listingValue: 1520000,
    updatedAt: 'há 4 horas',
  },
  {
    id: 'SF-902',
    propertyId: '1002',
    address: properties[1].address,
    buyer: 'Ricardo Nunes',
    status: 'Aceita',
    payment: 'À vista',
    creditStatus: 'Documentos em análise',
    value: 1260000,
    listingValue: 1290000,
    updatedAt: 'há 2 dias',
  },
];

export const salePaymentMethods = ['À vista', 'Financiado', 'À vista + FGTS', 'Financiado + FGTS'];

export const registrationSteps = [
  {
    id: 'location',
    title: 'Localização',
    status: 'PENDING',
    description: 'Endereço, número, complemento, CEP, bairro, cidade, estado e regionId.',
  },
  {
    id: 'propertyDetails',
    title: 'Dados do imóvel',
    status: 'PENDING',
    description: 'Tipo de imóvel, área, quartos, banheiros, vagas, suítes e itens disponíveis.',
  },
  {
    id: 'ownerInformation',
    title: 'Responsável pelo imóvel',
    status: 'ATTENTION',
    description: 'Nome, telefone, e-mail e permissão para contato da assistente.',
  },
  {
    id: 'rentPricing',
    title: 'Preço de aluguel',
    status: 'PENDING',
    description: 'Aluguel, IPTU, condomínio, taxa de administração e total do proprietário.',
  },
  {
    id: 'salePricing',
    title: 'Preço de venda',
    status: 'DISABLED',
    description: 'Valor de venda, análise de preço e documentos necessários para TIC.',
  },
  {
    id: 'photoScheduling',
    title: 'Sessão de fotos',
    status: 'ATTENTION',
    description: 'Agendar agora, reagendar ou continuar sem fotos.',
  },
  {
    id: 'rentVisitPriority',
    title: 'Visitas de aluguel',
    status: 'PENDING',
    description: 'Horários, entrada no imóvel e responsáveis pela confirmação.',
  },
  {
    id: 'saleVisitPriority',
    title: 'Visitas de venda',
    status: 'PENDING',
    description: 'Disponibilidade, responsável pelas chaves e modelo de entrada.',
  },
];

export const registrationFiles = [
  { id: 'file-1', name: 'matricula-imovel.pdf', progress: 100, type: 'PDF' },
  { id: 'file-2', name: 'iptu-2026.pdf', progress: 100, type: 'PDF' },
  { id: 'file-3', name: 'fotos-sala.zip', progress: 64, type: 'ZIP' },
];

export const registrationFeedbackCards = [
  {
    id: 'submit-error',
    kind: 'critical',
    title: 'Tivemos um problema ao enviar o cadastro',
    subtitle:
      'As informações do imóvel já estão salvas, mas não foi possível concluir o envio. Aguarde alguns minutos e tente novamente.',
    action: 'Tentar novamente',
  },
  {
    id: 'load-error',
    kind: 'critical',
    title: 'Tivemos um problema ao carregar as informações',
    subtitle: 'O carregamento das informações falhou, aguarde alguns minutos e tente novamente',
    action: 'Sair do Cadastro',
  },
  {
    id: 'duplicate',
    kind: 'critical',
    title: 'Não é possível cadastrar esse imóvel',
    subtitle: 'Esse imóvel já foi publicado no QuintoAndar por outra pessoa. Tente cadastrar outro imóvel.',
    action: 'Cadastrar outro imóvel',
  },
  {
    id: 'photo-error',
    kind: 'critical',
    title: 'Tivemos um problema ao agendar a sessão de fotos',
    subtitle:
      'Você não precisa preencher os dados do imóvel novamente, apenas agendar as fotos do anúncio. Aguarde alguns minutos e tente novamente.',
    action: 'Agendar mais tarde',
  },
];

export const registrationSuccessSteps = [
  ['Aguarde a confirmação do proprietário', 'Enviamos uma mensagem ao proprietário para confirmar o cadastro do imóvel.'],
  ['Copie o link e envie para o proprietário', 'Também vamos enviar uma mensagem automática para o proprietário.'],
  ['Agende a sessão de fotos', 'Após a confirmação do proprietário, você precisará agendar a sessão de fotos.'],
];

export const draftRows = [
  {
    id: 'draft-1001',
    propertyId: '1001',
    owner: 'Helena Paiva',
    status: 'Em andamento',
    reason: 'Finalize o cadastro',
    updatedAt: '13/07/2026',
    draftSection: 'ongoing',
    businessContext: 'aluguel e venda',
  },
  {
    id: 'draft-1002',
    propertyId: '1002',
    owner: 'Mauro Montenegro',
    status: 'Aguardando confirmação',
    reason: 'Contate o proprietário',
    updatedAt: '12/07/2026',
    draftSection: 'submitted',
    businessContext: 'aluguel',
  },
  {
    id: 'draft-1003',
    propertyId: '1003',
    owner: 'Barbara Mayer',
    status: 'Recusado pelo proprietário',
    reason: 'Descarte o imóvel',
    updatedAt: '11/07/2026',
    draftSection: 'submitted',
    businessContext: 'venda',
  },
];

export const photoSessions = [
  {
    id: 'photo-1001',
    propertyId: '1001',
    session: '16/07/2026 às 10:30',
    entry: 'Chaves com corretor',
    status: 'Para agendar',
    filter: 'TO_SCHEDULE',
    availableFrom: 'A partir de 15/07/2026',
  },
  {
    id: 'photo-1002',
    propertyId: '1002',
    session: '18/07/2026 às 14:00',
    entry: 'Chaves na portaria',
    status: 'Agendadas',
    filter: 'SCHEDULED',
    availableFrom: 'A partir de 18/07/2026',
  },
  {
    id: 'photo-1003',
    propertyId: '1003',
    session: 'Concluída em 10/07/2026',
    entry: 'Caixinha porta-chaves QuintoAndar (Lockbox)',
    status: 'Aguardando publicação',
    filter: 'WAITING_PUBLICATION',
    availableFrom: 'A partir de 10/07/2026',
  },
];

export const posReportSections = [
  {
    id: 'ccv',
    title: 'Compromissos de compra e venda (CCVs) assinados',
    subtitle:
      'Evolução dos CCVs (compromissos de compra e venda) assinados e ticket médio (valor médio de cada venda) dentro do período selecionado.',
    metrics: [
      ['Valor transacionado no período', 'R$ 4.250.000'],
      ['CCVs no período', '3'],
      ['Ticket médio', 'R$ 1.416.667'],
    ],
  },
  {
    id: 'published',
    title: 'Anúncios Publicados',
    subtitle:
      'Total acumulado de imóveis publicados no QuintoAndar até o momento e o tráfego (número de acessos no site), considerando o período selecionado.',
    metrics: [
      ['Anúncios publicados (até a data)', '42'],
      ['Tráfego médio no período', '1.240/semana'],
      ['Tráfego (acessos no QuintoAndar)', '4.960'],
    ],
  },
  {
    id: 'offers',
    title: 'Propostas enviadas versus aceitas',
    subtitle:
      'Evolução e taxa de conversão de propostas, considerando ofertas enviadas e ofertas aceitas dentro do período selecionado.',
    metrics: [
      ['Propostas enviadas', '18'],
      ['Propostas aceitas', '4'],
      ['Conversão de ofertas', '22%'],
    ],
  },
  {
    id: 'visits',
    title: 'Visitas agendadas versus realizadas',
    subtitle:
      'Evolução e taxa de conversão de visitas, considerando visitas agendadas e realizadas dentro do período selecionado.',
    metrics: [
      ['Visitas agendadas', '36'],
      ['Visitas realizadas', '24'],
      ['Conversão de visitas', '67%'],
    ],
  },
];

export const propertyTabs = [
  ['summary', 'Resumo'],
  ['details', 'Detalhes'],
  ['visits', 'Visitas'],
  ['rent_offers', 'Propostas de aluguel'],
];

export const similarTransactions = [
  {
    id: 'tx-1',
    label: 'Mesmo condomínio',
    address: 'Rua Visconde de Pirajá, 210 - Ipanema',
    context: 'Venda',
    date: 'vendido em 05/06/2026',
    price: 1290000,
    area: 86,
  },
  {
    id: 'tx-2',
    label: 'Menos de 100m de distância',
    address: 'Rua General Urquiza, 90 - Leblon',
    context: 'Aluguel',
    date: 'alugado em 22/05/2026',
    price: 6900,
    area: 94,
  },
  {
    id: 'tx-3',
    label: 'Valor por m²',
    address: 'Rua Dias Ferreira, 480 - Leblon',
    context: 'Venda',
    date: 'vendido em 18/04/2026',
    price: 1610000,
    area: 118,
  },
];

export const propertyPriceBands = [
  ['Abaixo dos similares na região', 'Pra quem quer ter mais chance de fechar negócio muito rápido.'],
  ['Na média dos similares na região', 'Pra atrair interessados e negociar com tranquilidade, é o preço ideal.'],
  ['Acima de 70% de similares', 'Menor chance de alugar. Preço acima do mercado na região.'],
  ['Acima de 90% de similares', 'Pouca chance de vender. Preço muito acima do mercado na região.'],
];

export const integrationParameters = [
  ['Valor mínimo', 'R$ 2.500'],
  ['Valor máximo', 'R$ 18.000'],
  ['Bairros', 'Leblon, Ipanema / + 2 bairros'],
];

export const propertyEditOptions = [
  ['DESCRIPTION', 'Descrição do imóvel', 'Editar texto público do anúncio.'],
  ['DETAILS', 'Características', 'Área, quartos, vagas, banheiros, mobília e itens.'],
  ['PRICE', 'Alteração de preço', 'Alterações feitas aqui são somente para o QuintoAndar.'],
  ['ENTRY_DETAILS', 'Entrada no imóvel', 'Modelo de acesso, responsável e instruções.'],
  ['STATUS', 'Status do anúncio', 'Pausar, reativar ou desativar publicação.'],
  ['PHOTOS', 'Sessão de fotos', 'Agendamento, reagendamento ou cancelamento.'],
];

export const leadEntities = {
  SALE: {
    leadUuid: 'lead-1001',
    propertyId: '1001',
    title: 'Aguardando confirmação de disponibilidade do proprietário',
    headline:
      'Enviamos uma mensagem via WhatsApp para o proprietário confirmar se o imóvel realmente está disponível.',
    primaryAction: 'Confirmar disponibilidade',
    status: 'WAITING_CONFIRMATION',
    listingStatus: 'Aguardando confirmação',
    processingText: 'O anúncio está sendo preparado',
    modalTitle: 'Confirmação de disponibilidade do imóvel',
    modalBody:
      'Confirme apenas se o proprietário validou que o imóvel está disponível para venda no Marketplace.',
  },
  RENT: {
    leadUuid: 'lead-1001',
    propertyId: '1001',
    title: 'Anúncio com pendências',
    headline: 'O imóvel não possui fotos. O anúncio fica bloqueado até regularizar os itens.',
    primaryAction: 'Marcar pendências como resolvidas',
    status: 'PENDING',
    listingStatus: 'Pendente no CRM',
    processingText: 'O imóvel entrará em imóveis em processamento após a atualização.',
    modalTitle: 'Marcar pendências como resolvidas',
    modalBody:
      'As pendências serão marcadas como resolvidas e o imóvel volta para imóveis em processamento.',
  },
};

export const members = [
  {
    id: 'user-1',
    name: 'Andre Admin',
    email: 'andre.admin@app2.local',
    profile: 'Perfil administrador',
    status: 'Ativo',
  },
  {
    id: 'user-2',
    name: 'Claudete Galeasso',
    email: 'claudete@app2.local',
    profile: 'Perfil corretor',
    status: 'Convite enviado',
  },
  {
    id: 'user-3',
    name: 'Bruna Almeida',
    email: 'bruna@app2.local',
    profile: 'Perfil de convidado',
    status: 'Pendente',
  },
];

export const operationAreas = [
  ['Rio de Janeiro', 'Leblon', '120 imóveis elegíveis'],
  ['Rio de Janeiro', 'Ipanema', '96 imóveis elegíveis'],
  ['Rio de Janeiro', 'Botafogo', '74 imóveis elegíveis'],
  ['São Paulo', 'Pinheiros', '88 imóveis elegíveis'],
];

export const priceActivities = [
  ['Visualizações', 1240, '+18%'],
  ['Contatos', 86, '+11%'],
  ['Visitas agendadas', 18, '+6%'],
  ['Propostas enviadas', 4, '+2'],
];

export const reportMetrics = [
  ['Propostas enviadas', '18'],
  ['Propostas aceitas', '4'],
  ['Visitas agendadas', '36'],
  ['Visitas realizadas', '24'],
];
